import {
  CcfBox,
  CcfButton,
  CcfCard,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-co-browse-session.module.scss';
import { CcfCoBrowseIcon, useTranslator } from '@nice-ccf/ui-controls';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCoBrowsingSessionStarted,
  setCoBrowsingSessionStarted,
} from '../ccf-inbox.slice';
import { getCoBrowsingSessionClosed } from '../../ccf-interaction-workspace/ccf-interaction-space.slice';
import { useMsal } from '@azure/msal-react';

/* eslint-disable-next-line */
export interface CcfCoBrowseSessionProps {}

/**
 * CcfCustomerCard used to disply Co browsing session
 * @param props --? - CcfCoBrowseSessionProps
 * @example -- <CcfCoBrowseSession />
 */
export function CcfCoBrowseSession(props: CcfCoBrowseSessionProps) {
  const [translate] = useTranslator();
  const dispatch = useDispatch();
  const {  accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || " ";
  const loginCredentialsArray = loginCredentialsFromSSO?.split(" ");
  const agentFirstName = loginCredentialsArray[0].charAt(0).toUpperCase() + loginCredentialsArray[0].slice(1).toLowerCase();
  const agentSurName = loginCredentialsArray[1].charAt(0).toUpperCase() + loginCredentialsArray[1].slice(1).toLowerCase();
  
  const isCoBrowsingSessionClosed = useSelector(getCoBrowsingSessionClosed);
  const isCoBrowsingSessionStarted = useSelector(getCoBrowsingSessionStarted);
  const time = new Date();
  const displayCurrentTime = time.toLocaleString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  /**
   * Function to handle Join Agent Button click
   * @param id - string
   * @example - joinAgentHandler()
   */
  const joinAgentHandler = () => {
    dispatch(setCoBrowsingSessionStarted(true));
  };

  return (
    <>
      <CcfBox className={styles.agentName}>{agentFirstName +" " + agentSurName}</CcfBox>
      <CcfCard className={styles.coBrowseCard}>
        <CcfBox className={styles.sideA}>
          <CcfCoBrowseIcon className={styles.coBrowseIcon} />
        </CcfBox>
        <CcfBox className={styles.sideB}>
          <CcfBox>
            <CcfTypography className={styles.title}>{translate('coBrowse')}</CcfTypography>
          </CcfBox>
          {!isCoBrowsingSessionClosed ? (
            <>
              <CcfBox>
                <CcfTypography className={styles.description}>
                {translate('coBrowseWithAgent')}
                </CcfTypography>
              </CcfBox>
              <CcfButton
                className={styles.joinBtn}
                onClick={joinAgentHandler}
                disabled={isCoBrowsingSessionStarted}
              >
                <CcfTypography
                  className={styles.joinBtnTxt}
                  style={{
                    color: isCoBrowsingSessionStarted ? '#8E9CAB' : '#003d7a',
                  }}
                >
                  {translate('joinAgent')}
                </CcfTypography>
              </CcfButton>
            </>
          ) : (
            <CcfBox>
              <CcfTypography className={styles.description}>
              {`${translate('coBrwosingSessionEnd')} ${displayCurrentTime}`} .
              </CcfTypography>
            </CcfBox>
          )}
        </CcfBox>
      </CcfCard>
    </>
  );
}

export default CcfCoBrowseSession;
